var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTransactionLg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.25 23.4998L18.75 10.5248",
    stroke: "#3F7DBC",
    strokeWidth: 4.58824,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5 40V20C52.4991 19.1232 52.2676 18.262 51.8288 17.5029C51.3901 16.7438 50.7593 16.1134 50 15.675L32.5 5.675C31.7399 5.23616 30.8777 5.00513 30 5.00513C29.1223 5.00513 28.2601 5.23616 27.5 5.675L10 15.675C9.24066 16.1134 8.60995 16.7438 8.17115 17.5029C7.73236 18.262 7.5009 19.1232 7.5 20V40C7.5009 40.8768 7.73236 41.738 8.17115 42.4971C8.60995 43.2562 9.24066 43.8866 10 44.325L27.5 54.325C28.2601 54.7638 29.1223 54.9949 30 54.9949C30.8777 54.9949 31.7399 54.7638 32.5 54.325L50 44.325C50.7593 43.8866 51.3901 43.2562 51.8288 42.4971C52.2676 41.738 52.4991 40.8768 52.5 40Z",
    stroke: "#3F7DBC",
    strokeWidth: 4.58824,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.1748 17.4L29.9998 30.025L51.8248 17.4",
    stroke: "#3F7DBC",
    strokeWidth: 4.58824,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30 55.2V30",
    stroke: "#3F7DBC",
    strokeWidth: 4.58824,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionLg);
export default __webpack_public_path__ + "static/media/TransactionLg.91f773484d42e263989717394518aea6.svg";
export { ForwardRef as ReactComponent };